import React from 'react'
import styles from "./style.module.scss"
import ReactLoading from 'react-loading';
import useWindowSize from '../../hooks/useWindowSize';

const Question: React.FC = () => {
   const
      { width } = useWindowSize(),
      widthLoad = (width / 2) > 500 ? 500 : width - 50

   return (
      <ReactLoading type={'bars'} color={"#ffffff"} height={200} width={widthLoad} />
   )
}

export default Question